import script from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CSelect.vue?vue&type=style&index=0&id=3a8269e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8269e8"]])

export default __exports__